"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anunciante = exports.SeguiData = exports.VerAprobacion = void 0;
var React = require("react");
var FetchAnuncios_1 = require("./FetchAnuncios");
var reactstrap_1 = require("reactstrap");
var reactstrap_2 = require("reactstrap");
//import imgAnuncio from "./img-anuncio.JPG";
var io5_1 = require("react-icons/io5");
var url_js_1 = require("../variables/url.js");
var espolAds_1 = require("../variables/espolAds");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var categorias = localBack + 'api/Catalog/Categorias';
var audiencia = localBack + 'api/Catalog/Audiencia';
var revisor = localBack + 'api/catalog/revisor/';
var seguimientos = localBack + 'api/Catalog/seguimientos';
var areas = localBack + 'api/Catalog/Area';
var VerAprobacion = /** @class */ (function (_super) {
    __extends(VerAprobacion, _super);
    function VerAprobacion(props) {
        var _this = _super.call(this, props) || this;
        _this.abrirModal = function () {
            _this.setState({ abierto: !_this.state.abierto });
        };
        _this.abrirAModal = function () {
            _this.setState({ abiertoA: !_this.state.abierto });
        };
        _this.cerrarModal = function () {
            _this.setState({ abierto: false });
        };
        _this.cerrarAModal = function () {
            _this.setState({ abiertoA: false });
        };
        _this.state = {
            title: "", loading: true, abierto: false, abiertoA: false, visible: true,
            dtoData: new FetchAnuncios_1.AnunciosData(), seg: new SeguiData,
            coment: "", esReiterativo: 0, categoriaList: [], audienciaList: [], areas: [],
            anunciante: new Anunciante, hideAprobar: false, status: 0
        };
        fetch(categorias)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ categoriaList: data });
        });
        fetch(audiencia, {
            method: 'GET',
            headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ audienciaList: data });
        });
        fetch(areas)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ areas: data });
        });
        var dtoid = _this.props.match.params["id"];
        // This will set state for Edit employee  
        if (dtoid > 0) {
            fetch(revisor + dtoid, {
                method: 'GET',
                headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
            })
                .then(function (response) {
                _this.setState({ status: response.status });
                return response.json();
            })
                .then(function (data) {
                _this.setState({
                    title: "Edit", loading: false, dtoData: data['anuncio'],
                    anunciante: data['gestor'],
                    esReiterativo: data['anuncio'].bdIsReiterativo ? 1 : 0
                });
            });
        }
        // This will set state for Add employee  
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.onDismiss = _this.onDismiss.bind(_this);
        return _this;
        //this.hideComponent = this.hideComponent.bind(this);
        // This binding is necessary to make "this" work in the callback  
    }
    VerAprobacion.prototype.handleSearch = function (event) {
        this.setState({ coment: event.target.value });
        /*console.log(this.state.coment);*/
    };
    VerAprobacion.prototype.renderSwitch = function (param) {
        switch (param) {
            case 'A':
                return false;
            case 'U':
                return false;
            default:
                return true;
        }
    };
    VerAprobacion.prototype.handleHistory = function (id) {
        this.props.history.push("/ver-historial/review/" + id);
    };
    VerAprobacion.prototype.handleInputChange = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var rest = value ? 1 : 0;
        this.setState({ esReiterativo: rest });
    };
    VerAprobacion.prototype.handleSave = function (coment, estado) {
        var _this = this;
        //let forma = new FormData(event.target);
        this.state.seg.IdAnuncio = this.state.dtoData.idAnuncio;
        this.state.seg.TxObservacion = coment;
        this.state.seg.BdEstado = estado;
        this.state.seg.BdIsReiterativo = this.state.esReiterativo;
        var seguimiento = this.state.seg;
        console.log(seguimiento);
        var data = JSON.stringify(seguimiento);
        /*console.log(data);*/
        {
            fetch(seguimientos, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                body: data,
            }).then(function (response) { return response.json(); })
                .then(function (responseJson) {
                _this.props.history.push("/reviewer/aprobar-anuncio");
            });
        }
        this.cerrarModal();
    };
    VerAprobacion.prototype.handleCancel = function () {
        this.props.history.push("/reviewer/aprobar-anuncio");
    };
    VerAprobacion.prototype.onDismiss = function () {
        this.setState({ visible: false });
    };
    VerAprobacion.prototype.end = function () {
        espolAds_1.expiro();
        this.props.history.push('/general/principal');
    };
    VerAprobacion.prototype.render = function () {
        var contents = (this.state.status == 0)
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : (this.state.status != 200 && this.state.status != 201) ? this.end()
                : this.renderComunicado(this.state.categoriaList);
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "APROBACI\u00D3N DE COMUNICADOS")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    // Returns the HTML Form to the render() method.  
    VerAprobacion.prototype.renderComunicado = function (categoriaList) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.CardHeader, null,
                React.createElement("p", { className: "title" }, "Vista Previa del Comunicado")),
            React.createElement(reactstrap_1.CardBody, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { md: 12 },
                        React.createElement(reactstrap_1.Card, null,
                            React.createElement(reactstrap_1.CardBody, { className: "main-content mb-12" },
                                React.createElement("div", null,
                                    React.createElement(reactstrap_1.Row, null,
                                        React.createElement(reactstrap_1.Col, { sm: "6" },
                                            React.createElement(reactstrap_1.Card, { key: this.state.dtoData.idAnuncio, body: true },
                                                React.createElement("a", { href: this.state.dtoData.txImagen, target: "_blank" },
                                                    React.createElement("img", { src: this.state.dtoData.txImagen, alt: "anuncio", className: "img-fluid" })),
                                                React.createElement("br", null),
                                                React.createElement(reactstrap_1.CardText, null))),
                                        React.createElement(reactstrap_1.Col, { sm: "6" },
                                            React.createElement(reactstrap_1.Card, { key: this.state.dtoData.idAnuncio, body: true },
                                                React.createElement("br", null),
                                                React.createElement("h5", null, this.state.dtoData.txTitulo),
                                                React.createElement(reactstrap_1.CardText, null,
                                                    React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Tipo:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.bdTipo == "E" ? "Evento" : "Anuncio")),
                                                    React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "\u00C1rea:"),
                                                        this.state.areas.map(function (area) {
                                                            return area.idArea == _this.state.dtoData.idArea
                                                                ? React.createElement("strong", { className: "valor" },
                                                                    "\u00A0\u00A0",
                                                                    area.txNombreArea)
                                                                : React.createElement(React.Fragment, null);
                                                        })),
                                                    React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Categor\u00EDa:"),
                                                        categoriaList.map(function (categoria) {
                                                            if (_this.state.dtoData.idCategoria == categoria.idCategoria)
                                                                return React.createElement("strong", { key: categoria.idCategoria, className: "valor" },
                                                                    " \u00A0\u00A0",
                                                                    categoria.txNombreCategoria);
                                                        })),
                                                    this.state.dtoData.audiencias != null
                                                        ?
                                                            React.createElement(React.Fragment, null,
                                                                React.createElement("div", { className: "titulo-anuncio" }, "Audiencias Objetivo: "),
                                                                React.createElement("ul", null, this.state.audienciaList.map(function (aud) {
                                                                    return _this.state.dtoData.audiencias.includes(aud.idAudiencia) ?
                                                                        React.createElement("li", null,
                                                                            React.createElement("strong", { className: "valor" }, aud.txNombre))
                                                                        : React.createElement(React.Fragment, null);
                                                                })))
                                                        : React.createElement(React.Fragment, null),
                                                    this.state.dtoData.txUrl == null ? null : React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Enlace:"),
                                                        " ",
                                                        React.createElement("a", { href: this.state.dtoData.txUrl, target: "_blank" },
                                                            " ",
                                                            React.createElement("strong", null,
                                                                "\u00A0\u00A0",
                                                                this.state.dtoData.txUrl.length > 60 ? React.createElement(React.Fragment, null, this.state.dtoData.txUrl.substring(0, 60) + "...") : React.createElement(React.Fragment, null, "" + this.state.dtoData.txUrl.substring(0, 60))))),
                                                    this.state.dtoData.txLugar == null ? null : React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Lugar:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.txLugar)),
                                                    this.state.dtoData.bdAmbito == null ? null : React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "\u00C1mbito:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.bdAmbito == "A" ? "Abierto" : "Interno")),
                                                    this.state.dtoData.dtPublicacion == null ? null : React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Fecha Publicaci\u00F3n:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.dtPublicacion.split("T")[0])),
                                                    this.state.dtoData.dtVigencia == null ? null : React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Fecha Vigencia:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.dtVigencia.split("T")[0])),
                                                    React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Publicaci\u00F3n Autom\u00E1tica:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.bdPublicarAutomatico ? "Sí" : "No")),
                                                    React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Comunicado Reiterativo:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.bdIsReiterativo ? "Sí" : "No")),
                                                    this.state.dtoData.dtVigencia ? null : React.createElement("div", { className: "form-group row" },
                                                        React.createElement("div", { className: "titulo-anuncio" }, "Vigencia:"),
                                                        " ",
                                                        React.createElement("strong", { className: "valor" },
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.dtVigencia.split("T")[0])),
                                                    this.state.dtoData.txTexto == null ? null : React.createElement("div", null,
                                                        React.createElement("div", { className: "form-group row" },
                                                            React.createElement("br", null),
                                                            React.createElement("div", { className: "titulo-anuncio" }, "Descripci\u00F3n:"),
                                                            React.createElement("br", null)),
                                                        React.createElement("div", { className: "form-group row" },
                                                            React.createElement("strong", { className: "valor" }, this.state.dtoData.txTexto)))))))))))),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Card, { key: this.state.dtoData.idAnuncio, body: true },
                        React.createElement(reactstrap_1.CardBody, null,
                            React.createElement("p", { className: "title" }, "Datos del Anunciante"),
                            React.createElement(reactstrap_1.CardText, null,
                                this.state.anunciante.unidad == null ? null : React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "titulo-anuncio" }, "Unidad:"),
                                    " ",
                                    React.createElement("strong", null,
                                        "\u00A0\u00A0",
                                        this.state.anunciante.unidad)),
                                this.state.anunciante.area == null ? null : React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "titulo-anuncio" }, "Area:"),
                                    " ",
                                    React.createElement("strong", null,
                                        "\u00A0\u00A0",
                                        this.state.anunciante.area)),
                                this.state.anunciante.txNombres == null ? null : React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "titulo-anuncio" }, "Nombre:"),
                                    " ",
                                    React.createElement("strong", null,
                                        "\u00A0\u00A0",
                                        this.state.anunciante.txNombres,
                                        "\u00A0\u00A0",
                                        this.state.anunciante.txApellidos)),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "titulo-anuncio" }, "Enviado:"),
                                    " ",
                                    React.createElement("strong", null,
                                        "\u00A0\u00A0",
                                        this.state.dtoData.dtEnvio != null ? this.state.dtoData.dtEnvio.split("T")[0] : null)),
                                this.state.dtoData.bdTipo == 'A' ? React.createElement(React.Fragment, null) : React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "titulo-anuncio" }, "Duraci\u00F3n Evento:"),
                                    " ",
                                    React.createElement("strong", null,
                                        "\u00A0\u00A0 desde \u00A0\u00A0",
                                        this.state.dtoData.dtInicio.split("T")[0],
                                        "\u00A0\u00A0"),
                                    " - ",
                                    React.createElement("strong", null,
                                        "\u00A0\u00A0 hasta \u00A0\u00A0 ",
                                        this.state.dtoData.dtFin.split("T")[0])))))),
                React.createElement("div", { className: "form-group row menu" },
                    React.createElement("label", { className: " control-label col-md-8", htmlFor: "Name" }),
                    React.createElement("div", { className: "col-md-4" },
                        this.renderSwitch(this.state.dtoData.bdEstado) ?
                            React.createElement("button", { className: "btn-info btn-round", onClick: function (id) { return _this.handleSave("", "A"); } }, "Aprobar") : React.createElement(React.Fragment, null),
                        "\u00A0\u00A0\u00A0",
                        React.createElement("button", { className: "btn-warning btn-round", onClick: function (id) { return _this.handleHistory(_this.state.dtoData.idAnuncio); } }, "Historial"),
                        "\u00A0\u00A0\u00A0",
                        React.createElement("button", { className: "btn-success btn-round", onClick: function (id) { return _this.abrirModal(); } }, "Devolver"),
                        "\u00A0\u00A0\u00A0",
                        React.createElement("button", { hidden: true, className: "btn-warning btn-round", onClick: this.handleCancel }, "Cancelar")))),
            React.createElement(reactstrap_2.Modal, { isOpen: this.state.abierto },
                React.createElement(reactstrap_2.ModalHeader, null, "Retroalimentaci\u00F3n"),
                React.createElement(reactstrap_2.ModalBody, null,
                    React.createElement("label", { className: "control-label col-md-2", htmlFor: "Name" }, "Comentario: "),
                    React.createElement("br", null),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("textarea", { className: "form-control", name: "txObservacion", defaultValue: this.state.seg.TxObservacion, onChange: this.handleSearch, required: true }))),
                React.createElement(reactstrap_2.ModalFooter, null,
                    React.createElement("button", { className: "btn-info btn-round", onClick: function () { return _this.handleSave(_this.state.coment, "R"); } }, "Enviar"),
                    React.createElement("button", { className: "btn-success btn-round", onClick: function () { return _this.cerrarModal(); } }, "Cancelar"))),
            React.createElement(reactstrap_2.Modal, { isOpen: this.state.abiertoA },
                React.createElement(reactstrap_2.ModalHeader, null, "Retroalimentaci\u00F3n para Aprobaci\u00F3n"),
                React.createElement(reactstrap_2.ModalBody, null,
                    React.createElement(reactstrap_2.Alert, { color: "danger", isOpen: this.state.visible, toggle: this.onDismiss, style: { fontSize: "1.3vw" } },
                        React.createElement(io5_1.IoAlertCircleOutline, { size: '2vw' }),
                        "\u00A0 Estimado revisor, ahora podra aprobar anuncios y decidir si estos deben ser reiterativos para ser mostrados hasta el final de su vigencia en el mail masivo."),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("label", { className: "control-label col-md-6", htmlFor: "Name" }, "Comunicado Reiterativo*"),
                        React.createElement("div", { className: "col-md-2" },
                            React.createElement("input", { className: "form-control", name: "bdIsReiterativo", type: "checkbox", checked: this.state.esReiterativo == 1, onChange: this.handleInputChange, value: "true" }))),
                    React.createElement("label", { className: "control-label col-md-2", htmlFor: "Name" }, "Comentario: "),
                    React.createElement("br", null),
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("textarea", { className: "form-control", name: "txObservacion", defaultValue: this.state.seg.TxObservacion, onChange: this.handleSearch, required: true }))),
                React.createElement(reactstrap_2.ModalFooter, null,
                    React.createElement("button", { className: "btn-info btn-round", onClick: function () { return _this.handleSave(_this.state.coment, "A"); } }, "Aprobar"),
                    React.createElement("button", { className: "btn-success btn-round", onClick: function () { return _this.cerrarAModal(); } }, "Cancelar")))));
    };
    return VerAprobacion;
}(React.Component));
exports.VerAprobacion = VerAprobacion;
var SeguiData = /** @class */ (function () {
    function SeguiData() {
        this.IdAnuncio = 0;
        this.TxObservacion = "";
        this.BdEstado = "";
        this.BdIsReiterativo = 0;
    }
    return SeguiData;
}());
exports.SeguiData = SeguiData;
var Anunciante = /** @class */ (function () {
    function Anunciante() {
        this.unidad = 0;
        this.area = 0;
        this.txApellidos = "";
        this.txNombres = "";
    }
    return Anunciante;
}());
exports.Anunciante = Anunciante;
//# sourceMappingURL=VerAprobacion.js.map